import type { CreatePaymentMethodReq } from '../../../services/customer/types';
import type { Agent } from '../../../services/commonCheckout/types/CheckoutSessionsResponse';
import type { CardCategoriesType } from '../../../shared/types/CardCategories/CardCategoriesType';


export function createPaymentMethodRequest(
  tokenizedCardId: string,
  isDefault: boolean,
  nickname: string,
  name: string,
  isManufacturerCard: boolean,
  agent: Agent | null,
  cardCategories: CardCategoriesType,
): Record<'paymentMethod', CreatePaymentMethodReq> {
  return {
    paymentMethod: {
      type: 'CARD',
      vendorPaymentMethodId: tokenizedCardId,
      vendor: 'STRIPE',
      default: isDefault,
      nickname,
      paymentMethodDetails: {
        type: 'CARD',
        nameOnCard: name,
        manufacturerCard: isManufacturerCard,
        cardCategories,
      },
      sourceProvider: {
        name: 'CCG',
      },
      agent,
      authRequired: true,
      paymentMethodSourceDetails: {
        channel: 'WEBFORM',
        uiSourceFragment: 'STRIPE',
      },
    },
  };
}
